module.exports = __webpack_public_path__ + "media/acuity/macro_themes-0a4b403f.svg";